// language=GraphQL
export const ALL_ROOM_TYPES_QUERY = `query Query($withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
  roomTypes: accommodationRoomTypes {
    id
    name
    description
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_ROOM_TYPE_QUERY = `query Query($id: ID!, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
  roomType: accommodationRoomType(id: $id) {
    id
    name
    description
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const CREATE_ROOM_TYPE_MUTATION = `
  mutation Mutation($input: CreateAccommodationRoomTypeInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
    roomType: createAccommodationRoomType(input: $input) {
      id
      name
      description
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_ROOM_TYPE_MUTATION = `
  mutation Mutation($input: UpdateAccommodationRoomTypeInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {
    roomType: updateAccommodationRoomType(input: $input) {
      id
      name
      description
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_ROOM_TYPE_MUTATION = `
  mutation Mutation($input: DeleteAccommodationRoomTypeInput) {
    deleteAccommodationRoomType(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ROOM_TYPE_MUTATION = `
  mutation Mutation($input: DeleteAccommodationRoomTypeInput) {
    forceDeleteAccommodationRoomType(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ROOM_TYPES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelAccommodationAssignments: Boolean = false, $withAccommodations: Boolean = false) {
  groupedDependents: accommodationRoomTypeDependents(id: $id) {
    travelAccommodationAssignments @include(if: $withTravelAccommodationAssignments) {
      id
      useCustomRoomTypeSelection    }
    accommodations @include(if: $withAccommodations) {
      id
      label
      name
      stars
      description
    }
  }
}`
